// @flow
import React, { type Node } from 'react';
import './MainTemplate.scss';

type Props = {
  children: Node,
};

const MainTemplate = ({ children }: Props) => <div className="MainTemplate">{children}</div>;

export default MainTemplate;



// WEBPACK FOOTER //
// ./src/components/main/MainTemplate/MainTemplate.js